"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var t = require("io-ts");
function method(arg, result) {
    return {
        argValidator: arg,
        resultValidator: result,
    };
}
exports.method = method;
function service(p) {
    return {
        props: p,
        codec: t.intersection([
            t.type({
                tag: t.keyof(p),
            }),
            // value is partial because the key of an `undefined` value is removed
            // through JSON encoding. Because `undefined` is the natural encoding
            // of `void`, we simply deal with this little bit of inconvenience.
            t.partial({
                value: t.string,
            }),
        ]),
    };
}
exports.service = service;
function extend(s1, s2) {
    return service(__assign(__assign({}, s2.props), s1.props));
}
exports.extend = extend;
var ValidatorCodec = /** @class */ (function (_super) {
    __extends(ValidatorCodec, _super);
    function ValidatorCodec(name, validator) {
        return _super.call(this, name, function (i) { return validator(i) === true; }, function (i, c) { return (validator(i) === true ? t.success(i) : t.failure(i, c)); }, t.identity) || this;
    }
    return ValidatorCodec;
}(t.Type));
exports.ValidatorCodec = ValidatorCodec;
